export default __webpack_public_path__ + "static/media/family-image.640d2ff4.svg";